// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","teacherMode":"App_teacherMode__A5Rgw","withAppFooter":"App_withAppFooter__Ps4A-"};